/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_IpInputs */

const cs_gdpr_col_ip = /** @type {(inputs: Gdpr_Col_IpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP / prohlížeč`)
};

const en_gdpr_col_ip = /** @type {(inputs: Gdpr_Col_IpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP / browser`)
};

/**
* | output |
* | --- |
* | "IP / browser" |
*
* @param {Gdpr_Col_IpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_ip = /** @type {((inputs?: Gdpr_Col_IpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_IpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_ip(inputs)
	return cs_gdpr_col_ip(inputs)
});